import { useSelector } from 'react-redux';
export function useObserver(element) {
    var _a;
    const observer = (_a = element) === null || _a === void 0 ? void 0 : _a.observer;
    if (!observer) {
        return element;
    }
    return useSelector((state) => {
        var _a, _b, _c, _d;
        const storedState = state.Storage[observer.storageGroup] &&
            state.Storage[observer.storageGroup][observer.storageKey];
        const currentState = storedState === undefined ? observer.defaultState : storedState;
        return _d = (_c = (_b = (_a = observer) === null || _a === void 0 ? void 0 : _a.states) === null || _b === void 0 ? void 0 : _b[currentState], (_c !== null && _c !== void 0 ? _c : currentState)), (_d !== null && _d !== void 0 ? _d : observer.defaultValue);
    });
}
